import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const FEATURES = [
  { id: 'birth_chart',      name: 'Mapa Natal',         icon: '🌟', path: '/birth-chart',     time: '30 min' },
  { id: 'forecast_daily',   name: 'Previsão Diária',    icon: '☀️', path: '/forecast',         time: '5 min'  },
  { id: 'forecast_weekly',  name: 'Previsão Semanal',   icon: '📅', path: '/forecast',         time: '10 min' },
  { id: 'forecast_monthly', name: 'Previsão Mensal',    icon: '🌙', path: '/forecast',         time: '15 min' },
  { id: 'forecast_yearly',  name: 'Previsão Anual',     icon: '🗓️', path: '/forecast',         time: '30 min' },
  { id: 'synastry',         name: 'Sinastria',          icon: '💕', path: '/synastry',          time: '20 min' },
  { id: 'tarot',            name: 'Tarô',               icon: '🃏', path: '/tarot',             time: '10 min' },
  { id: 'numerology',       name: 'Numerologia',        icon: '🔢', path: '/numerology',        time: '15 min' },
  { id: 'palmistry',        name: 'Quiromancia',        icon: '✋', path: '/quiromancy',        time: '15 min' },
  { id: 'graphology',       name: 'Grafologia',         icon: '✍️', path: '/questions',         time: '15 min' },
  { id: 'i_ching',          name: 'I Ching',            icon: '☯️', path: '/i-ching',           time: '10 min' },
  { id: 'human_design',     name: 'Design Humano',      icon: '🧬', path: '/human-design',      time: '25 min' },
  { id: 'vedic_astrology',  name: 'Astrologia Védica',  icon: '🕉️', path: '/vedic-astrology',   time: '20 min' },
];

export function FeatureChecklist() {
  const [usedFeatures, setUsedFeatures] = useState<Set<string>>(new Set());
  const [loading, setLoading]           = useState(true);

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (!user) { setLoading(false); return; }
      supabase
        .from('feature_usage')
        .select('feature_name')
        .eq('user_id', user.id)
        .then(({ data }) => {
          setUsedFeatures(new Set((data ?? []).map((r: { feature_name: string }) => r.feature_name)));
          setLoading(false);
        });
    });
  }, []);

  const explored = usedFeatures.size;
  const total    = FEATURES.length;
  const pct      = Math.round((explored / total) * 100);

  return (
    <div className="min-h-screen bg-[#0D1130] py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-[#C9A84C] text-2xl tracking-[8px] mb-2" aria-hidden="true">✦</div>
          <h1 className="text-[#C9A84C] text-3xl font-light tracking-wider mb-4">Sua Jornada</h1>
          <p className="text-[#F5ECD7]/80 mb-6">
            Você explorou{' '}
            <strong className="text-[#C9A84C]">{loading ? '…' : explored} de {total}</strong> sistemas
          </p>
          <div className="max-w-md mx-auto h-1 bg-[#C9A84C]/20 rounded-full overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
            <div
              className="h-full bg-[#C9A84C] transition-all duration-700"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f) => {
            const done = usedFeatures.has(f.id);
            return (
              <Link
                key={f.id}
                to={f.path}
                aria-label={`${f.name}, ${done ? 'já explorado' : 'ainda não explorado'}`}
                className={`
                  block p-6 border rounded-sm transition-all
                  ${done
                    ? 'border-[#C9A84C] bg-[#C9A84C]/10'
                    : 'border-[#C9A84C]/30 hover:border-[#C9A84C] hover:bg-[#C9A84C]/5'}
                `}
              >
                <div className="flex items-start justify-between mb-3">
                  <span className="text-3xl" aria-hidden="true">{f.icon}</span>
                  {done && <span className="text-[#C9A84C] text-xl" aria-hidden="true">✓</span>}
                </div>
                <h3 className="text-[#C9A84C] font-light text-lg mb-1">{f.name}</h3>
                <p className="text-[#F5ECD7]/50 text-xs tracking-wider uppercase">
                  {f.time} · {done ? 'Explorado' : 'Descobrir'}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
